import { ShowLegacy } from 'interfaces/generated.types';

export const getShowName = (show: ShowLegacy) =>
  `${show.name} - ${show.show_id} - ${show.hostingPlatform}`;

export const getShowNameOption = (show: ShowLegacy) => ({
  value: show.show_id,
  label: getShowName(show),
});

export const getShowNameOptions = (allShowsLegacy: ShowLegacy[]) =>
  allShowsLegacy.map((show) => getShowNameOption(show));
